import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {UtilService} from "../../shared/services/util.service";
import { MaterialModule } from "src/app/app.materials";
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-access',
  templateUrl: './access.component.html',
  styleUrls: ['./access.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MaterialModule, FormsModule],
  standalone: true,
})
export class AccessComponent implements OnInit {

  @Input() allIndices: any[] = [];
  @Input() indices: any[] = [];
  @Input() label = 'live access';
  @Output() indexChange: EventEmitter<any>;

  accessSelect = '';

  constructor(
    private util: UtilService
  ) {
    this.indexChange = new EventEmitter<any>();
  }

  ngOnInit(): void {
  }

  checkIndexInList(idx) {
    return this.indices.findIndex(index => index.id === idx.id);
  }

  removeIndex(idx) {
    const sliceIndex = this.checkIndexInList(idx);
    if (sliceIndex >= 0) {
      this.indices = this.util.findAndReplaceItemInArray(idx, this.indices, true);
    }
    this.indexChange.emit();
  }

  addIndex(idx) {
    setTimeout(() => { this.accessSelect = ''; }, 100);
    const sliceIndex = this.checkIndexInList(idx);
    if (sliceIndex >= 0) {
      return false;
    }
    this.indices.push(idx);
    this.indexChange.emit();
  }
}
